import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import closeIcon from 'assets/close-modal.svg';

import styles from './styles.module.scss';

const CreatePersonaModal = ({
  isOpen,
  personaName,
  standardSummary,
  onSave,
  onClose,
  isSaving,
}) => {
  const [editedName, setEditedName] = useState(personaName);

  if (!isOpen) {
    return null;
  }

  const handleSave = useCallback(() => {
    if (!editedName.trim()) {
      return;
    }

    onSave(editedName.trim());
  }, [editedName, onSave]);

  const handleNameChange = useCallback(e => {
    setEditedName(e.target.value);
  }, []);

  return (
    <div className={styles['persona-modal-overlay']}>
      <div className={styles['persona-modal']}>
        <div className={styles['modal-header']}>
          <h2 className={styles['modal-title']}>
            Create a user persona
          </h2>
          <button
            type="button"
            className={styles['modal-close-btn']}
            onClick={onClose}
          >
            <img src={closeIcon} alt="Close" className={styles['close-icon']} />
          </button>
        </div>

        <div className={styles['modal-body']}>
          <input
            type="text"
            value={editedName}
            onChange={handleNameChange}
            placeholder="Persona name"
            maxLength={255}
            className={styles['name-input']}
          />

          <p className={styles['standard-summary']}>
            {standardSummary}
          </p>
        </div>

        <div className={styles['modal-footer']}>
          <button
            type="button"
            disabled={!editedName.trim() || isSaving}
            onClick={handleSave}
            className={cn(styles['save-btn'], {
              [styles['save-btn--disabled']]: !editedName.trim() || isSaving,
            })}
          >
            {isSaving ? 'Saving...' : 'Save persona'}
          </button>
        </div>
      </div>
    </div>
  );
};

CreatePersonaModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  personaName: PropTypes.string.isRequired,
  standardSummary: PropTypes.string.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
};

CreatePersonaModal.defaultProps = {
  isSaving: false,
};

export default CreatePersonaModal;
